import { SelectorOption } from "../../../../components/Redux/BasicSelector";

export const LoadBalancerOptions: SelectorOption[] = [
  {
    label: "None Selected",
    id: "",
  },
  {
    label: "Round Robin",
    id: "round_robin",
  },
  {
    label: "Least Request",
    id: "least_request",
  },
  {
    label: "Ring Hash",
    id: "ring_hash",
  },
  {
    label: "Random",
    id: "random",
  },
  {
    label: "Maglev",
    id: "maglev",
  },
];
